export default "__VITE_ASSET__DChJZiQK__"